import { render } from "./B2bPageEstadisticasRechazadas.vue?vue&type=template&id=513b6162&scoped=true&lang=pug"
import script from "./B2bPageEstadisticasRechazadas.vue?vue&type=script&lang=js"
export * from "./B2bPageEstadisticasRechazadas.vue?vue&type=script&lang=js"

import "./B2bPageEstadisticasRechazadas.vue?vue&type=style&index=0&id=513b6162&lang=scss&scoped=true"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-513b6162"]])

export default __exports__